function deltaConverter (delta) {
  const ops = delta.ops
  let flatText = ''
  for (let i = 0; i < ops.length; i++) {
    let text = ops[i].insert
    if (text === '\n') {
      flatText += text
      continue
    }
    if (ops[i].attributes) {
      for (const key in ops[i].attributes) {
        switch (key) {
          case 'bold':
            text = `**${text}**`
            break
          case 'italic':
            text = `*${text}*`
            break
          case 'underline':
            text = `_${text}_`
            break
          case 'align':
            if (ops[i].attributes.key === 'center') {
              text = `>${text}<`
            }
            break
        }
      }
    }
    flatText += text
  }
  return flatText
}

module.exports = deltaConverter
